import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import './PageWrapper.less';
import { COUNTRY } from '../../../App/AppConstants';

export class PageWrapper extends PureComponent {
    static propTypes = {
        country: PropTypes.oneOf(Object.values(COUNTRY)),
        isLoading: PropTypes.bool,

        // Passed in props
        children: PropTypes.node.isRequired,
        pageName: PropTypes.string.isRequired
    };

    render() {
        const {
            children,
            country,
            pageName
        } = this.props;
        const wrapperClasses = [
            'PageWrapper',
            `${country}-wrapper`,
            pageName
        ];
        return (
            <div className={wrapperClasses.join(' ')}>
                {children}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    country: _.get(state, 'serverData.country', COUNTRY.UNITED_STATES),
    isLoading: _.get(state, 'spinner.isVisible', false)
});

export default connect(mapStateToProps)(PageWrapper);
